import React, { useState } from 'react';
import { Button, Form, Input, Select, Toast } from '../../../../Components';
import { FaArrowRight } from 'react-icons/fa';

function DepartmentsNTeams({onSubmit=()=>{}, details={}, onBack=()=>{}}) {
    
    const [Values, setValues] = useState({
        name: '',
        head: {},
    });

    const handleSubmit = () => {
        if(!Values.name){
            return Toast.error('Please enter a department name');
        }
        onSubmit({
            ...Values,
            head: Values.head.value
        });
    }

    return ( 
        <div className='text-center fade-in-right p-10'>
            <h1 className='text-4xl font-bold'>Add Department</h1>
            <div className='mt-2 text-xl font-thin'>Add Department in your office, you can also add more later</div>
            <Form onSubmit={handleSubmit} className='mt-8 flex flex-col gap-4 max-w-[400px] m-auto'>
                <Input value={Values.name} onChange={name=>setValues(prev=>({...prev, name}))} required placeholder='Department Name'/>
                {
                    details.users?.length > 0 &&
                    <Select placeholder='Select Department Head for Approvals' btnClass='w-full' 
                        options={details.users.map(user=>({
                            label: user, value: user
                        }))}
                        onChange={user=>setValues(prev=>({...prev, head: user}))}
                        selected={Values.head}
                    />
                }
                <div className='flex gap-x-2 mt-4 max-w-min m-auto'>
                    <Button onClick={onBack} className='flex-grow'>Back</Button>
                    <Button type='submit' variant='primary' className='flex-grow'>Continue <FaArrowRight className='ml-2'/></Button>
                </div>
            </Form>
        </div>
     );
}

export default DepartmentsNTeams;